import '../../css/Aviso.css';
export function mostrarAviso(){
    const eAviso = document.querySelector('#aviso');

    eAviso.classList.remove('d-none');

    setTimeout(()=>{
        eAviso.style.opacity = '1';
    }, 10);
}
export function ocultarAviso(){
    const eAviso = document.querySelector('#aviso');

    setTimeout(()=>{
        eAviso.style.opacity = '0';
        setTimeout(() => {
            eAviso.classList.add('d-none');
        }, 450);
    }, 10);
}
export default function Aviso({mensaje, tipo}){
    const definirTipoAlerta = () => {
        switch (tipo) {
            case 'd':
                return 'alert alert-danger';
                break;
            case 's':
                return 'alert alert-danger';
                break;
            case 'p':
                return 'alert alert-danger';
                break;
            case 'w':
                return 'alert alert-warning';
                break;
        }
    }
    return (
        <div id='aviso' className={`${definirTipoAlerta()} d-none`} data-bs-theme='dark'>{mensaje}</div>
    );
}